import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StardustCursor from "../components/StardustCursor";
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <>
      <StardustCursor />
      <Header />
      {/* Animated Gradient Wave at Top */}
      <div style={{ position: 'fixed', width: '100vw', height: '100vh', overflow: 'hidden', top: 0, left: 0, zIndex: -10 }}>
        <svg
          className="wave-svg"
          viewBox="0 0 1440 900"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          style={{ position: 'absolute', top: 0, left: 0, width: '100vw', height: '100vh', minWidth: '100vw', maxWidth: '100vw', transform: 'scaleY(-1)' }}
        >
          <defs>
            <linearGradient id="splashGradient" x1="0" y1="0" x2="1440" y2="0" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#A9D8E3" />
              <stop offset="20%" stopColor="#F1DCAD" />
              <stop offset="40%" stopColor="#F7A072" />
              <stop offset="60%" stopColor="#D4C5E2" />
              <stop offset="80%" stopColor="#B6E2D3" />
              <stop offset="100%" stopColor="#F7A8B8" />
            </linearGradient>
          </defs>
          <path
            d="M0,180 C220,420 380,220 600,420 C800,700 1000,180 1200,600 C1300,850 1440,500 1440,500 V900 H0 Z"
            fill="url(#splashGradient)"
            opacity="0.85"
          />
          <path
            d="M0,350 Q400,180 800,500 T1440,350 V900 H0 Z"
            fill="url(#splashGradient)"
            opacity="0.5"
          />
        </svg>
        {/* Overlay for readability */}
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(255,255,255,0.68)', zIndex: 1, pointerEvents: 'none' }} />
      </div>
      <style>{`
            <section
              className="hero-section"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
                gap: "2.5rem",
                padding: "2rem 1.5rem 1.5rem",
                flexWrap: "wrap"
              }}
            >
              <img
                className="hero-image"
                src="/data/about/images/me_autumn.jpg"
                alt="Portrait of Daphna Keidar"
                style={{
                  width: 240,
                  height: 240,
                  borderRadius: '50%',
                  objectFit: "cover",
                  boxShadow: "0 6px 24px rgba(169, 216, 227, 0.25)",
                  flexShrink: 0,
                  marginBottom: 0
                }}
                onMouseOver={e => e.currentTarget.classList.add('capillary-wave')}
                onMouseOut={e => e.currentTarget.classList.remove('capillary-wave')}
              />
              <div className="hero-content" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", minWidth: 260, maxWidth: 600 }}>
                <h1 className="name-title" style={{ fontSize: '4em', fontWeight: 'normal', marginBottom: '0.3em', textAlign: 'left', color: '#222222', textShadow: '0 2px 12px rgba(44,95,111,0.13), 0 1px 2px #fff' }}>
                  Daphna Keidar
                </h1>
                <p style={{
                  fontSize: '1.3em',
                  lineHeight: 1.5,
                  maxWidth: 640,
                  textAlign: 'left',
                  color: '#222222',
                  marginBottom: '1.5rem',
                  textShadow: '0 2px 8px rgba(44,95,111,0.10), 0 1px 2px #fff'
                }}>
                  I love colourful messes, but also precise logic.
                  <br />
                  Welcome to my little corner of art and research.
                </p>
                {/* Interests labels */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px 14px', marginBottom: '1.2rem' }}>
                  {['AI', 'Data Visualization', 'Neuroscience', 'Art', 'Creativity'].map((interest, i) => (
                    <span key={i} style={{
                      background: '#222222',
                      color: '#ffffffff',
                      borderRadius: 14,
                      padding: '10px 16px',
                      fontWeight: 600,
                      fontSize: '1em',
                      letterSpacing: 0.2,
                      boxShadow: '0 1px 4px rgba(44,95,111,0.06)',
                      display: 'inline-block',
                    }}>{interest}</span>
                  ))}
                </div>
              </div>
            </section>
          }
          .buttons-container a {
            width: 100%;
            text-align: center;
          }
        }
      `}</style>
      <main>
        {/* Hero Section */}
        <section
          className="hero-section"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            padding: "2rem 1.5rem 1.5rem",
            // background: "linear-gradient(135deg, #F0F8FF 0%, #E6F3F5 100%)",
          }}
        >
          <div className="hero-content" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <h1 className="name-title" style={{ fontSize: '4em', fontWeight: 'normal', marginBottom: '0.2em', textAlign: 'center', color: '#222222', textShadow: '0 2px 12px rgba(44,95,111,0.13), 0 1px 2px #fff' }}>
              Daphna Keidar
            </h1>
            <p style={{
              fontSize: '1.3em',
              lineHeight: 1.5,
              maxWidth: 640,
              textAlign: 'center',
              color: '#222222',
              marginTop: 0,
              marginBottom: '1.2rem',
              textShadow: '0 2px 8px rgba(44,95,111,0.10), 0 1px 2px #fff'
            }}>
              I love colourful messes, but also precise logic.
              <br />
              Welcome to my little corner of art and research.
            </p>
          </div>
        </section>

        {/* Quick Links Section */}
        <section
          style={{
            maxWidth: 1000,
            margin: "1.2rem auto 3rem",
            padding: "0 1.5rem",
            textAlign: 'center'
          }}
        >
          <div className="buttons-container" style={{ display: 'flex', gap: '1.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/research" className="btn btn-research">See Research</Link>
            <Link to="/art" className="btn btn-art">Explore Art</Link>
          </div>
        </section>

      </main>
      <hr style={{ border: "none", borderTop: "1px solid #ccc", marginTop: "calc(8rem - 2px)" }} />
      <Footer />
    </>
  );
};

export default Home;
